module.exports = "<div class=\"rotate\" style=\"page-break-before: always;\" ng-repeat-start=\"stage in ctrl.stages\">\n  {{stage.name()}}\n</div>\n<div class=\"rotate\" style=\"page-break-before: always\" ng-repeat=\"event in stage.$schedule\" ng-repeat-end>\n  {{ctrl.getEventName(event)}}\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/stage-headers/tpl.html
// module id = 1203
// module chunks = 0